// import Vue from 'vue' // Vue实例有render可以使用的
import Vue from 'vue' // Vue实例 没有 render时候可以使用的
import App from './App.vue'
import router from './router'
import '@/assets/css/global.css'
import ElementUI from 'element-ui'
import axios from 'axios'
import md5 from 'js-md5'
import Fragment from 'vue-fragment'
import store from './store'
import { apiBaseURL } from '@/utils/apiBase'
import 'babel-polyfill'
import '@/assets/style/common.less'

require('babel-polyfill')

Vue.use(Fragment.Plugin)

// 历史地址仅作对照。实际前缀由 apiBaseURL 决定：本地走 /api 代理，正式直连系统接口。
// axios.defaults.baseURL = 'http://192.168.0.56:8681'
// axios.defaults.baseURL = 'http://47.114.158.115:8681'
// axios.defaults.baseURL = 'http://192.168.0.244:8681'
axios.defaults.baseURL = apiBaseURL

Vue.prototype.$http = axios
Vue.prototype.$md5 = md5

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
